function pushToCart(e) {
  e.preventDefault();
  e.stopPropagation();
  const randomId = generate12DigitRandomNumber();
  const variantId = document.querySelector('form[action="/cart/add"] input[name="id"]').value;
  const qty = document.querySelector('.quantity-selector__input').value;


  if (!variantId) return;

  const personalizationInputs = document.querySelectorAll('.pers_container input');
  const items = [];

  if (personalizationInputs.length === 0) {
    sendData(randomId, variantId, qty, null, items);
    return;
  }
  else if (personalizationInputs.length === 1) {
    sendData(randomId, variantId, qty, personalizationInputs[0].value, items);
    return;
  }

  personalizationInputs.forEach((input, index) => {
    if (index !== 0) {
      items.push({
        "id": 51135974506823,
        "quantity": qty,
        "properties": {
          "refId": randomId,
          "Personalización": input.value,
        }
      });
    }
  });

  sendData(randomId, variantId, qty, personalizationInputs[0].value, items);

}

async function sendData(randomId, variantId, qty, firstPersonalization, persItems) {
  console.log('Sending data to cart');
  const formData = {
    "items": [
      {
        "id": variantId,
        "quantity": qty,
        "properties": {
          "refId": randomId,
          ...(firstPersonalization && { "Personalización gratis": firstPersonalization })
        }
      }
    ]
  };

  if (persItems.length > 0) {
    formData.items.push(...persItems);
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    const data = await response.json();
    console.log('Success:', data);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.querySelector('a[aria-controls="cart-drawer"]').click();
  } catch (error) {
    console.error('Error:', error);
  }
}

function generate12DigitRandomNumber() {
  return Math.floor(100000000000 + Math.random() * 900000000000);
}